import React from 'react';
import {breakpoints} from '@ultradent/utilities/MediaQueries';
import {useMediaQuery} from '../../util/ReactHooks';

const {screenSmall, screenMedium, screenLarge} = breakpoints;

/**
 * input(em) -> tailwind.config -> breakPoints -> px
 *      26em:       sm -> screenSmall -> 416px
 *      47em:       md -> screenMedium -> 752px
 *      64.0625em:  lg -> screenLarge -> 1024px
 *      80em:       xl -> screenBase -> 1280px
 */

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const Mobile = props => {
    const isMobile = useMediaQuery( `(max-width: ${screenSmall}px)` );
    return isMobile ? <div {...props}/> : null;
}

export const Tablet = props => {
    const isTablet = useMediaQuery( `(min-width: ${screenMedium}px) and (max-width: ${screenLarge - 1}px)` );
    return isTablet ? <div {...props}/> : null;
}

export const HandheldDevice = props => {
    const isHandheldDevice = useMediaQuery( `(min-width: 0px) and (max-width: ${screenLarge - 1}px)` );
    return isHandheldDevice ? <div {...props}/> : null;
}

export const Desktop = props => {
    const isDesktop = useMediaQuery( `(min-width: ${screenLarge}px)` );
    return isDesktop ? <div {...props}/> : null;
}

export const SmallDevice = props => {
    const isSmallDevice = useMediaQuery( `(max-width: ${screenMedium - 1}px)` );
    return isSmallDevice ? <div {...props}/> : null;
}

// render for anything but Mobile devices
export const MediumDevice = props => {
    const isMediumDevice = useMediaQuery( `(min-width: ${screenMedium}px)` );
    return isMediumDevice ? <div {...props}/> : null;
}




